import React, { Component } from 'react'
import { Marker, GoogleMap, Polyline } from '@react-google-maps/api'
import polyline from '@mapbox/polyline'

const containerStyle = {
  width: '100%',
  height: '450px',
}

export default class TrackMap extends Component {
  constructor(props) {
    super(props)
    this.state = {
      path: [],
    }
  }
  onLoad = (polyline) => {}

  componentDidMount() {
    const path = []
    const polylinedata =
      'xt|Filn_FFe@`BkPAu@r@c[?}@?oAEyBAiAG{AEaBE_BAkBCsACwACyAEaBGeB?}AIeBCqA?}A?aBEaBKcBOeBM{Am@mAK{@MeBOmBQeBMcBMqAOsAOmBIyAMwASmA[sA`@w@dAXrABrAKnBKhBPlAd@rAn@dAh@nANrAIxAY~A]lBKtAKlASzASfBe@~AStAOpA[rAs@pAk@bBo@xAi@hAk@hAi@fAs@nAu@`BQrAe@jAc@jAk@vAo@xAm@nAm@lAi@hAq@`A{@r@eAd@eBJ{AC}AK}AMyA_@qAa@qAa@oAa@uA_@wA_@sAc@mAa@qA_@oAa@sA]mA]oAe@mAa@qAu@k@aA{@oAiAkA{@qA_AqAaAmA{@sAy@{A{@_Bo@yAa@mA_@sAYm@s@q@iAo@iAe@qAY_BSsAQuAW{AS}AM}AK}AIwAIuAIsAOaBm@gASg@d@g@bAa@vAs@tAi@bBg@jAe@tAm@tAk@zAg@zAi@zAk@`Bm@bBs@`Bk@zAg@vAg@pAe@hAe@nAg@`Bi@`Bs@fAo@~@k@x@i@t@e@nAs@[g@h@Iv@u@d@u@x@yAp@gAf@sAd@aAh@qAt@uAj@wAh@iAx@kA|@_Al@mAf@{Ah@sAl@yAt@aBx@iBj@iAz@aB|@}Ax@gBn@yAh@yAj@oAh@kAf@oAb@wAr@uA~@oAd@mAl@q@z@gAr@yAl@oAn@wAj@kAv@}Aj@gAj@gA~@{@h@y@r@}Aj@mAj@mAx@{Aj@kAl@gAl@oAl@qAn@qAn@sAr@yAZmAb@oAj@iAp@qAn@uAt@aBf@oAj@qAl@{Af@wAXyAXgBRgBNkBDqBCqBKqBSsBQwBOsBQwBQuBOqBOiBMiBGeBMgBOgBMcBKcBMeBMgBKaBIsACuAEoAOgBOsBM{AK{AMaBKiBMsAK{AO}AOcBMgBOmBQqBKwBKsAIqAOoBM_BOaB?wA?qAJ}ANkBNcBV}AZ}Ad@}Ab@oAd@mAf@kAj@kAn@iAr@eAt@gAp@_Az@_Az@{@|@eAx@}@|@kAx@_Ax@cAbAsAhAmAbAkA`AgAv@gAz@}@x@y@`AiA|@aAv@eA`AoAfAqAz@aAx@iA|@kA`AgAbAiAdAiA`AmAbAqAbAmAdAoAdAuAfAqAhAqAhAqAjAqAjAsAhAyAlAwAhAwAjAuAhAqAbAiA|@cA|@{Ap@_Af@{@r@sAb@gATwAEwA?}AFoAFqALeB?gAP_ARsA^eBEoA[_Bc@}Ae@sAm@wAk@cAs@gAs@iAs@kAs@gAu@eAgA}@_A{@_@uAg@iAk@mAs@mA}@yA_AqAy@iAu@kAs@eAaAmAaAqAu@eAo@iAq@iAs@mAs@mAu@kA}@qAaAsA_AsAaAuAcAwAaA}AcAyAeA{AcA}AcA{A_AwA_AsAy@qAy@mAsAw@kA^y@z@y@j@s@d@kAx@u@h@uA~@mAt@Wz@u@zAcAN'
    if (polylinedata) {
      const polies = polyline.decode(polylinedata)
      polies.map((pol) => {
        const item = { lat: pol[0], lng: pol[1] }
        return path.push(item)
      })
      this.setState(path)
    }
  }

  render() {
    const options = {
      strokeColor: '#019444',
      strokeOpacity: 0.8,
      strokeWeight: 4,
      fillColor: '#019444',
      fillOpacity: 0.25,
      clickable: false,
      draggable: false,
      editable: false,
      visible: true,
      radius: 30000,
      paths: this.state.path,
      zIndex: 1,
    }
    const center = {
      lat: parseFloat(this.props.lat) ?? -1.2984236831337772,
      lng: parseFloat(this.props.lng) ?? 36.77894253283739,
    }

    return (
      <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={12}>
        {/* Child components, such as markers, info windows, etc. */}
        <Polyline
          onLoad={this.onLoad}
          path={this.state.path}
          options={options}
        />
        <Marker onLoad={this.onLoad} position={center} />
      </GoogleMap>
    )
  }
}
